import { selectActiveFeature } from './selectActiveFeature';
import { IApplicationState } from '../../types/redux';

export const selectNewbuildingInfo = (state: IApplicationState) => {
  const activeFeature = selectActiveFeature(state);

  return activeFeature && activeFeature.properties.newbuilding;
};
